import bilAPI from '../api';

export const getMockupsStats = (params) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/exam/account_exam_result/`, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject('axios error');
        });
    } catch (error) {
      reject('system error');
    }
  });
};
